import React, { useState } from 'react';

function ProgressPhotoUpload({ label, name, setValue }) {
  const photoUpload = React.createRef();

  const [photo, setPhoto] = useState();

  function onPhotoChange(e) {
    if (e.target.files[0]) {
      setPhoto(URL.createObjectURL(e.target.files[0]));
      setValue(name, e.target.files[0]);
    }
  }

  return (
    <div className="photos-list-block">
      <h5>{label}</h5>
      {photo ? (
        ''
      ) : (
        <button
          type="button"
          className="btn btn-greyishBrown"
          onClick={() => photoUpload.current.click()}
        >
          <i className="fas fa-plus"></i> Upload Photo
        </button>
      )}
      <input
        type="file"
        ref={photoUpload}
        id={name}
        accept="image/*"
        name={name}
        hidden={true}
        onChange={onPhotoChange}
      />
      {photo ? (
        <div className="uploaded-photo">
          <img src={photo} alt="Progress" />
          <button
            type="button"
            onClick={() => photoUpload.current.click()}
            className="btn btn-gray"
          >
            <i className="fas fa-sync-alt"></i>
          </button>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}

export default ProgressPhotoUpload;
